// src/components/TransferModal.js
import React, { useState, useEffect } from 'react';
import { getAllUsers, transferPoints } from '../services/api';
import pointsIcon from '../assets/points_icon.png';
import UserSearchInput from './UserSearchInput';

export default function TransferModal({ currentUser, onTransferSuccess }) {
    const [users, setUsers] = useState([]);
    const [recipientId, setRecipientId] = useState('');
    const [amount, setAmount] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Загружаем всех пользователей, кроме текущего
        getAllUsers().then(res => {
            setUsers(res.data.filter(user => user.id !== currentUser.id));
        });
    }, [currentUser.id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');

        const recipient = users.find(user => user.id === recipientId);
        if (!recipient) {
            setMessage('Ошибка: получатель не найден.');
            setIsLoading(false);
            return;
        }
        const recipientName = recipient.serverNickname || recipient.username;

        try {
            await transferPoints({ recipientId: recipientId, recipientName: recipientName, amount: parseInt(amount) });
            setMessage('Перевод выполнен успешно!');
            // Очищаем форму
            setRecipientId('');
            setAmount('');
            // Вызываем коллбэк для обновления данных на дашборде
            setTimeout(() => {
                onTransferSuccess();
            }, 1000); // Небольшая задержка, чтобы пользователь успел прочитать сообщение
        } catch (error) {
            setMessage(error.response?.data?.error || 'Ошибка перевода.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="transfer-modal">
            <h2>Перевести очки</h2>
            <p>Вы переводите свои несгораемые (общие) очки.</p>
            <form onSubmit={handleSubmit} className="transfer-form">
                <label>Получатель:</label>
                <UserSearchInput
                    users={users.filter(u => u.id !== currentUser.id)} // Исключаем себя из списка
                    onUserSelect={setRecipientId}
                />

                <label>Сумма:</label>
                {/* --- ИЗМЕНЕНИЕ: Оборачиваем инпут и иконку в один контейнер --- */}
                <div className="amount-input-wrapper">
                    <input type="number" value={amount} onChange={e => setAmount(e.target.value)} min="1" required />
                    <img src={pointsIcon} alt="points" className="points-icon" />
                </div>

                <button type="submit" disabled={isLoading}>{isLoading ? 'Переводим...' : 'Перевести'}</button>
            </form>
            {message && <p className="form-message">{message}</p>}
        </div>
    );
}